import service from '../../../../http/httpApiApplication';

export const baseUrl = '/registrationfield';

export const enable = (id?: string) => {
  return service.put(`${baseUrl}/${id}/enable`, {});
};

export const disable = (id?: string) => {
  return service.put(`${baseUrl}/${id}/disable`, {});
};
